import {
  ApproveRegistrationFormSchema,
  BillingFormSchema,
  ContractFormSchema,
  PatientFormSchema,
  PaymentFormSchema,
  PersonFormSchema,
  ProviderTypeFormSchema,
  RegistrationFormSchema,
  RoleFormSchema,
  TenantFormSchema,
  UtilCategoryFormSchema,
  UtilServiceFormSchema,
  UtilServicePublicFormSchema,
  VisitFormSchema,
  WaiverFormSchema,
  // DEFAULT IMPORT ADD
} from "./form.rule";

export const loginFormDefault = {
  username: "",
  password: "",
};
export const tenantFormDefault = {
  owner: "",
  businessName: "",
  businessType: "",
  description: "",
  avatar: "",
  email: "",
  mobileNumber: "",
  phoneNumber: "",
  website: "",
  membershipDate: "" as any,
  rewardsType: "",
  slug: "",
  postRegistrationLink: "",
  enablePublicBookingTimeSelection: false,
  dailyBookingLimit: undefined,
  bookingLimitMessage: "",
  showAppointmentDetails: false,
  showServicesInPublicBooking: false,
  defaultDate: "" as any,
} as TenantFormSchema;
export const roleFormDefault = {
  name: "",
  description: "",
} as RoleFormSchema;
export const personFormDefault = {
  tenant: "",
  role: "",
  firstName: "",
  middleName: "",
  lastName: "",
  username: "",
  email: "",
  password: "",
  isVerified: false,
  avatar: "",
  activationCode: "",
  gender: "",
  birthday: "" as any,
  isBlocked: false,
  mobileNumber: "",
  fatherName: "",
  motherName: "",
  emergencyContact_1Number: "",
  emergencyContact_1Name: "",
  emergencyContact_1Relationship: "",
  emergencyContact_2Number: "",
  emergencyContact_2Name: "",
  emergencyContact_2Relationship: "",
  sss: "",
  philhealth: "",
  pagibig: "",
  tin: "",
  medicalCondition: "",
  bloodType: "",
  elementary: "",
  highSchool: "",
  college: "",
  postCollege: "",
  undergraduate: "",
  curriculumVitae: "",
  supportingDoc: "",
  intentLetter: "",
  applicationLetter: "",
  photo: undefined,
} as PersonFormSchema;
export const patientFormDefault = {
  tenant: "",
  firstName: "",
  middleName: "",
  lastName: "",
  birthday: "",
  gender: "",
  address: "",
  email: "",
  mobileNumber: "",
  photo: undefined,
  isTakingMedication: false,
  medicationDetails: "",
  hasAllergies: false,
  allergyDetails: "",
  hasMedicalConditions: false,
  medicalConditionDetails: "",
  wasRecentlyUnwell: false,
  unwellDetails: "",
  otherMedicalConditions: "",
} as PatientFormSchema;
export const utilServiceFormDefault = {
  tenant: "",
  category: "",
  name: "",
  description: "",
  amount: 0,
} as UtilServiceFormSchema;
export const contractFormDefault = {
  tenant: "",
  patient: "",
  service: "",
  signature: "",
  amount: 0,
  file: undefined,
  session: 0,
  patientName: "",
  serviceName: "",
  personName: "",
  person: "",
  waiver: "",
  waiverName: "",
  waiverChecks: [],
} as ContractFormSchema;
export const billingFormDefault = {
  contract: "",
  session: 0,
} as BillingFormSchema;
export const providerTypeFormDefault = {
  name: "",
  description: "",
  tenant: "",
} as ProviderTypeFormSchema;

export const paymentFormDefault = {
  billing: "",
  amountPaid: 0,
  status: "",
  avatar: "",
  provider: "",
  attachment: undefined,
  contract: "",
} as PaymentFormSchema;
export const visitFormDefault = {
  patient: "",
  contract: "",
  billing: "",
  date: "",
  time: "",
  description: "",
  prescription: "",
  person: "",
  avatar: "",
  photos: undefined,
  attachment: undefined,
} as VisitFormSchema;
export const waiverFormDefault = {
  tenant: "",
  name: "",
  description: "",
  fontSize: 12,
  subtitle: "",
} as WaiverFormSchema;
export const registrationFormDefault = {
  tenant: "",
  firstName: "",
  middleName: "",
  lastName: "",
  birthday: "",
  gender: "",
  address: "",
  mobileNumber: "",
  avatar: "",
  email: "",
  isTakingMedication: false,
  medicationDetails: "",
  hasAllergies: false,
  allergyDetails: "",
  hasMedicalConditions: false,
  medicalConditonDetails: "",
  wasRecentlyUnwell: false,
  unwellDetails: "",
  otherMedicalConditions: "",
  service: "",
  serviceType: "",
  date: "",
  time: "",
  otherRemarks: "",
  consentAgreement: false,
  status: "PENDING",
} as RegistrationFormSchema;

export const approveRegistrationFormDefault = {
  code: "",
  status: "PENDING",
} as ApproveRegistrationFormSchema;

export const getPublicServiceFormDefault = {
  tenant: "",
} as UtilServicePublicFormSchema;
export const utilCategoryFormDefault = {
  tenant: "",
  name: "",
  description: "",
} as UtilCategoryFormSchema;
// DEFAULT ADD
